import { Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { BehaviorSubject, Observable, Subscription, combineLatest } from 'rxjs';
import { Avis } from '../../../models/avis';
import { Endpoints } from '../../../models/endpoints';
import { FormsEnum } from '../../../models/enums/forms.enum';
import { StatusHelper } from '../../shared/helpers/StatusHelper';
import { VisualiserMessages } from '../../shared/models/component-messages/visualiser-messages';
import { StatusState } from '../../shared/models/enum/statusState';
import { HttpService } from '../../shared/services/http.service';
import { LogService } from '../../shared/services/log.service';
import { AvisService } from '../services/avis-service';
import { PopupDupliquerComponent } from './popup-dupliquer/popup-dupliquer.component';
import { PopupEnregistrerComponent } from './popup-enregistrer/popup-enregistrer.component';
import { PopupSupprimerComponent } from './popup-supprimer/popup-supprimer.component';
import { Synthesis } from './synthese/model/synthesis';
import { CanNavigateInStepperService } from '../../shared/services/can-navigate-in-stepper.service';
import { AvisDataTransferService } from '../../shared/services/avis-data-transfer.service';
import {EnumMicroDroits} from '../../administration/models/micro.droits';
import {first} from 'rxjs/operators';
import {AuthorizationService} from '../../../authorization/services/authorization.service';
import {EformConditionsV2Service} from '../../formulaires/eforms/services/eform-conditions-v2.service';

@Component({
  selector: 'app-visualiser-avis-de-pub',
  templateUrl: './visualiser-avis-de-pub.component.html',
  styleUrls: ['./visualiser-avis-de-pub.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class VisualiserAvisDePubComponent implements OnInit, OnDestroy {


  private LOG: LogService = new LogService(VisualiserAvisDePubComponent);
  public status = new BehaviorSubject<StatusState>(null);
  public statusobs: Observable<string> = this.status.asObservable();
  public isNewActive = 1;
  public visualiserMessages = new VisualiserMessages();
  public referenceAvis = this.activatedRoute.snapshot.paramMap.get('numeroAvisPub');
  public statusHelper = StatusHelper;
  public forms: FormsEnum = null;
  public linkForms: FormsEnum[] = null;
  public hasUnsavedChanges: boolean;
  private subscriptions = new Subscription();
  public synthesis: BehaviorSubject<Synthesis> = new BehaviorSubject(new Synthesis());
  public currentJson: BehaviorSubject<any> = new BehaviorSubject(null);
  public linkableNotices =null;
  hasManageRight: boolean;

  constructor(
    private modalService: NgbModal,
    private activatedRoute: ActivatedRoute,
    private avisService: AvisService,
    private http: HttpService,
    private router: Router,
    private canNavigateInStepperService: CanNavigateInStepperService,
    private avisDataTransferService: AvisDataTransferService,
    private authorizationService: AuthorizationService,
    private eformConditionsV2Service: EformConditionsV2Service
  ) { }

  public diffBoamp = false;
  public diffJoue = false;


  public ngOnInit() {

    this.hasUnsavedChanges = false;
    this.subscriptions.add(
      this.avisService.synthesis$.subscribe((data) => {
        this.forms = data?.forms;
      })
    );
    this.linkableNotices=this.canNavigateInStepperService.linkableNotices;
    // - ----------------
    this.subscriptions.add(
      this.http.get(Endpoints.AVIS_FIND_SYNTHESE_BY_REFERENCE + this.referenceAvis, Synthesis).subscribe(data => {
        this.synthesis.next(data);
        data.supportDiffusionList?.forEach(diff => {
          if (diff.libelle === 'BOAMP') {
            this.diffBoamp = true;
          }
          if (diff.libelle === 'JOUE') {
            this.diffJoue = true;
          }
        });
        this.forms = data.forms;
        this.status.next(data.status);
      },
        error => {
          this.LOG.error(error);
        }));
    this.habilitations();
  }

  public backToList() {
    this.canNavigateInStepperService.selectedDiffuseurInitial = null;
    this.canNavigateInStepperService.linkableForms = [];
    this.canNavigateInStepperService.linkableNotices = [];
    this.canNavigateInStepperService.formulairevalues = null;
    this.router.navigate(['/avisdepublicite/listerAvisPub/']);
  }

  public modifier() {
    this.canNavigateInStepperService.selectedDiffuseurInitial = null;
    this.canNavigateInStepperService.linkableForms = [];
    this.canNavigateInStepperService.linkableNotices = [];
    this.canNavigateInStepperService.formulairevalues = null;
    this.router.navigate(['/avisdepublicite/editerAvisPub/' + this.referenceAvis]);
  }

  public lierAvis() {
    combineLatest([
      this.avisService.getAvisByReference(this.referenceAvis),
      this.avisService.getAvisByReferenceAvisConnexe(this.referenceAvis)
    ]).subscribe(data => {
      data[0].flux = data[0].flux.concat(data[1].flux);
      this.canNavigateInStepperService.setReferenceParent(data[0]);
      this.canNavigateInStepperService.linkableNotices = [data[0]];
      this.canNavigateInStepperService.isCreerAvisLierSelected=true;
      this.router.navigate(['/avisdepublicite/creerAvisPub/']);
    });
  }

  public lierAvisPub() {
    this.canNavigateInStepperService.currentFormulaire =this.canNavigateInStepperService.selectedAvisItemData.formulairecode;
        this.canNavigateInStepperService.currentNormeFormulaire = this.canNavigateInStepperService.selectedAvisItemData.norme;
        this.canNavigateInStepperService.linkableNotices =this.canNavigateInStepperService.selectedAvisItemData.reliables;
        this.canNavigateInStepperService.isEditAvisSelected=false;
        this.canNavigateInStepperService.isCreerAvisLierSelected=true;
        this.canNavigateInStepperService.creerAvisLierSelected=true;
        this.router.navigate(['/avisdepublicite/editerAvisPub/' + this.canNavigateInStepperService.selectedAvisItemData.numero]);
    this.canNavigateInStepperService.selectedAvisItemData=null;
  }

  public activeTab(state: number) {
    this.subscriptions.add(
      this.avisService.shouldUpdateSynthesis$.subscribe(() => {
        this.hasUnsavedChanges = false;
      })
    );

    if (this.hasUnsavedChanges) {
      this.modalService.open(PopupEnregistrerComponent);
    }

    this.isNewActive = state;
    if (this.isNewActive === 2) {
      document.getElementById('pills-one-tab').classList.remove('active');
      document.getElementById('pills-two-tab').classList.add('active');
    } else {
      document.getElementById('pills-two-tab').classList.remove('active');
      document.getElementById('pills-one-tab').classList.add('active');
    }
  }



  public getHasUnsavedChanges(hasUnsavedChanges: boolean) {
    this.hasUnsavedChanges = hasUnsavedChanges;
  }

  public supprimer() {
    const modalRef = this.modalService.open(PopupSupprimerComponent);
    modalRef.componentInstance.referenceAvis = this.referenceAvis;
    modalRef.componentInstance.idAvis = this.referenceAvis;
    this.canNavigateInStepperService.selectedDiffuseurInitial = null;
    this.canNavigateInStepperService.linkableForms = [];
    this.canNavigateInStepperService.linkableNotices = [];
    this.canNavigateInStepperService.formulairevalues = null;
    modalRef.result.then((result) => {
    }, (reason) => {
    }
    );
  }

  public telecharger() {
    this.subscriptions.add(
      this.avisService.generatePdf(this.referenceAvis, "fr").subscribe((data) => {
        let file = new Blob([data], { type: 'application/pdf' });
        let fileURL = URL.createObjectURL(file);
        //download
        const anchor = document.createElement('a');
        anchor.download = this.referenceAvis + '.pdf';
        anchor.href = fileURL;
        anchor.click();
      },
        (error) => {
          this.LOG.error(error);
        })
    );
  }

  public dupliquer() {
    this.subscriptions.add(
      this.avisService.duplicate(this.referenceAvis).subscribe(
        (data: Avis) => {
          this.modalService.open(PopupDupliquerComponent);
          this.canNavigateInStepperService.selectedDiffuseurInitial = null;
          this.canNavigateInStepperService.linkableForms = [];
          this.canNavigateInStepperService.linkableNotices = [];
          this.canNavigateInStepperService.formulairevalues = null;
          this.avisDataTransferService.sourceAppProfilAcheteurInfos = data.jsonSaisieFormulaire.sourceAppProfilAcheteurInfos;
          // 🔧 FIX 2026-02-23: Réinitialiser les flatFields pour éviter les données fantômes
          // lors de l'édition de l'avis dupliqué
          this.eformConditionsV2Service.resetFlatFields();
          this.router.navigate(['/avisdepublicite/listerAvisPub/']);
        },
        (error) => {
          this.LOG.error(error);
        })
    );
  }

  isLiable() {
    return this.canNavigateInStepperService.linkableForms?.length > 0;
  }

  isReliable() {
    return this.canNavigateInStepperService.linkableNotices?.length > 0;
  }

  private habilitations() {
    this.authorizationService.hasAnyMicroRightIn([EnumMicroDroits.AVIS_PUBLICITE_GESTION])
      .pipe(first())
      .subscribe(hasManageRight => { this.hasManageRight = hasManageRight });
  }

  ngOnDestroy(): void {
    this.avisService.synthesis = null;
    this.subscriptions.unsubscribe();
  }
}
